import * as types from "edu_lms/constants/actionsType";

export const onUpdateMockTestFilter = (data) => {
  return {
    type: types.PA_UPDATE_MOCK_TEST_FILTER,
    data,
  };
};
